import { loader } from 'graphql.macro'

export default function ticket ({ dataLoaders, queryKey }) {
  const [, id] = queryKey
  const schema = loader('./ticket.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { id })
}
